sectionRenderVariants();


function sectionRenderVariants(){
  const productTagsEl = document.querySelector(".product-tags");
  if (!productTagsEl) return;
  const variantTags = productTagsEl.getAttribute("data-tags");
  console.log(` current shop is ${window.themeVariables.strings.currentShop}`)
  const currentShop = window.themeVariables.strings.currentShop;
  const currentLanguage = window.themeVariables.strings.currentLanguage;

  // xoxo wildhearts met country selector fetcht via de routes-root; zonder de trailing slash,
  // anders wordt een root van '/' de protocol-relatieve URL '//search'
  const searchRoot = (currentShop == 'bwjecommerce' || currentShop == 'xoxo' && currentLanguage == 'nl')
    ? ''
    : window.Shopify.routes.root.replace(/\/$/, '');

  fetch(searchRoot + `/search?q=${variantTags}&section_id=section-variants`)
  .then(response => {
    if (!response.ok) throw new Error(`variant search returned ${response.status}`);
    return response.text();
  })
  .then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const sectionEl = doc.getElementById('shopify-section-section-variants');

    // section-variants rendert de slider-wrapper ook bij nul resultaten (#856)
    if (!sectionEl || !sectionEl.querySelector(".variants-slider .swiper-slide")) {
      hideVariantPicker();
      return;
    }

    document.querySelector('.section__render_variants').innerHTML = sectionEl.innerHTML;

    // Wacht tot de DOM update is verwerkt
    requestAnimationFrame(() => {
      document.querySelector(".variants-slider")?.classList.add("loaded");
      document.querySelector(".image__loader_wrap")?.classList.add("hidden-loader");
      mountVariantSliderNew();
      highlightActiveVariant();
    });
  })
  .catch(error => {
    console.warn('Variant picker hidden:', error);
    hideVariantPicker();
  });
}

// Geen zusterproducten (of een mislukte fetch): geen titel boven een lege strook
function hideVariantPicker() {
  document.querySelector('.sm-variants-title')?.classList.add('hidden');
  document.querySelector('.variant__wrap_with_loader')?.classList.add('hidden');
}

function highlightActiveVariant() {
  const currentHandle = document.querySelector('.product-page-handle')?.dataset.productHandle;
  console.log('test test 1');
  if (!currentHandle) return;

  console.log('test test 2');

  const slides = document.querySelectorAll('.variants-slider .swiper-slide');
  slides.forEach(slide => {
   console.log('test test 3'); 
    const slideHandle = slide.dataset.productHandle;
    if (slideHandle === currentHandle) {
      slide.classList.add('active');
    } else {
      slide.classList.remove('active');
    }
  });
}



// async function loadVariantProductsNew() {
//   const productTagsEl = document.querySelector(".product-tags");
//   if (!productTagsEl) return;

//   const variantTags = productTagsEl.getAttribute("data-tags");
//   const variantSettings = productTagsEl.getAttribute("data-variant-setting");
//   if (!variantTags || variantSettings !== "images") return;

//   const baseUrl = `/search?q=${variantTags}`;
//   const allSlides = [];

//   function sleep(ms) {
//     return new Promise(resolve => setTimeout(resolve, ms));
//   }

//   async function fetchPage(page = 1) {
//     // const res = await fetch(`${baseUrl}&page=${page}`);
//     const res = await fetch(`${baseUrl}&page=${page}&sections=section-variants`);
//     if (!res.ok) return; // stop als pagina niet geladen kan worden
//     const htmlString = await res.text();
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(htmlString, "text/html");

//     const variantWrapper = doc.querySelector(".hidden__variants_wrap");
//     if (variantWrapper) {
//       const slides = variantWrapper.querySelectorAll(".swiper-slide");
//       slides.forEach(slide => {
//         if (slide.dataset.tags === variantTags) {
//           allSlides.push(slide.cloneNode(true));
//         }
//       });
//     }

//     // Alleen pagina 2 ophalen
//     if (page < 2) {
//       await sleep(500); // wacht 0.5s om 429 te voorkomen
//       await fetchPage(page + 1);
//     }
//   }

//   try {
//     await fetchPage(1);

//     const targetWrapper = document.querySelector(".variants-slider .swiper-wrapper");
//     if (!targetWrapper) return;

//     targetWrapper.innerHTML = "";
//     allSlides.forEach(slide => targetWrapper.appendChild(slide));

//     document.querySelector(".variants-slider")?.classList.add("loaded");
//     mountVariantSliderNew();

//     // Loader fade-out + remove
//     const loaderEl = document.querySelector(".image__loader_wrap");
//     if (loaderEl) {
//       loaderEl.classList.add("hidden-loader"); // fade via CSS
//       setTimeout(() => loaderEl.remove(), 400); // na animatie weghalen
//     }
//   } catch (err) {
//     console.error("Fout bij laden van varianten:", err);
//   }
// }


function mountVariantSliderNew() {
  const variantSettings = document.querySelector(".product-tags")?.getAttribute("data-variant-setting");
  const container = document.querySelector(".variants-slider");

  if (!container || !variantSettings) return;

  // Basisafmetingen instellen
  let slideSize = {
    width: 75,
    height: 75
  };

  // Pas Swiper slide styles toe
  const slides = container.querySelectorAll(".swiper-slide");
  slides.forEach(slide => {
    slide.style.width = `${slideSize.width}px`;
    slide.style.height = `${slideSize.height}px`;
  });

  const swiper = new Swiper(".variants-slider", {
    slidesPerView: 10,
    spaceBetween: 10,
    speed: 700,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      0:{
        slidesPerView: 4,
      },
      767: {
        slidesPerView: 10,
      }
    }
  });

  // Overflow check: als alle slides passen → disable arrows en swipe
  requestAnimationFrame(() => {
    const wrapper = container.querySelector(".swiper-wrapper");
    const totalSlidesWidth = wrapper.scrollWidth;
    const visibleWidth = container.clientWidth;

    if (totalSlidesWidth <= visibleWidth) {
      swiper.allowTouchMove = false;
      const prevBtn = container.querySelector(".swiper-button-prev");
      const nextBtn = container.querySelector(".swiper-button-next");
      prevBtn?.classList.add("swiper-disabled");
      nextBtn?.classList.add("swiper-disabled");
    }
  });
}